import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SigningComponent } from './signing.component';
import { FillingHelperComponent } from './filling-helper/filling-helper.component';
import { FormsModule }   from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SignaturePadModule } from 'angular-signature-pad-v2';
import { SharedModule } from '../shared/shared.module';
import { AttachmentsModalComponent } from '../shared/attachments-modal/attachments-modal.component';

@NgModule({
    imports: [CommonModule,FormsModule, PdfViewerModule, SignaturePadModule, SharedModule, AttachmentsModalComponent],
    declarations: [SigningComponent, FillingHelperComponent],
    exports: [SigningComponent]
})

export class SigningModule { }
